// AUTO GENERATED FILE

import { ArrayCTA } from './components/ArrayCTA'
import { BasicHedgehogImage } from './components/BasicHedgehogImage'
import { BorderWrapper } from './components/BorderWrapper'
import { CallToAction } from './components/CallToAction'
import { Caption } from './components/Caption'
import { Images } from './components/Careers/Images'
import { CompensationCalculator } from './components/CompensationCalculator'
import { ContentViewer } from './components/ContentViewer'
import { lib } from './components/Edition/lib'
import { FeatureAvailability } from './components/FeatureAvailability'
import { GDPRForm } from './components/GDPRForm'
import { HiddenSection } from './components/HiddenSection'
import { HubSpotForm } from './components/HubSpotForm'
import { KeyboardShortcut } from './components/KeyboardShortcut'
import { LPCTA } from './components/LPCTA'
import { Label } from './components/Label'
import { List } from './components/List'
import { OverflowXSection } from './components/OverflowXSection'
import { Quote } from './components/Pricing/Quote'
import { ProductLayout } from './components/ProductLayout'
import { Quote2 } from './components/Quote2'
import { Signatures } from './components/Signatures'
import { SlackPage } from './components/SlackPage'
import { Squeak } from './components/Squeak'
import { StarRepoButton } from './components/StarRepoButton'
import { Startups } from './components/Startups'
import { TracksCTA } from './components/TracksCTA'
import { ZendeskTicket } from './components/ZendeskTicket'

export const shortcodes = {
    ArrayCTA,
    BasicHedgehogImage,
    BorderWrapper,
    CallToAction,
    Caption,
    Images,
    CompensationCalculator,
    ContentViewer,
    lib,
    FeatureAvailability,
    GDPRForm,
    HiddenSection,
    HubSpotForm,
    KeyboardShortcut,
    LPCTA,
    Label,
    List,
    OverflowXSection,
    Quote,
    ProductLayout,
    Quote2,
    Signatures,
    SlackPage,
    Squeak,
    StarRepoButton,
    Startups,
    TracksCTA,
    ZendeskTicket,
}
